module.exports = __webpack_public_path__ + "static/media/DanskeNarrow-Italic.dd7c599f.woff";